import { noPreferenceReducedMotion } from '../../functions/reducedMotion';
(function () {
    const startPageHero = document.getElementById('start-page-hero');
    if (!startPageHero)
        return;
    if (!noPreferenceReducedMotion)
        return;
    import('gsap').then(({ gsap }) => {
        const startPageHeroContent = document.getElementById('start-page-hero__content');
        const staggerItems = Array.from(startPageHeroContent?.querySelectorAll('[data-stagger-item]'));
        gsap.from(staggerItems, {
            y: -48,
            opacity: 0,
            duration: 0.6,
            stagger: 0.1,
            ease: 'back.out',
        });
    });
})();
//# sourceMappingURL=start-page-hero.js.map